module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/meal_preference/gluten_free--xxl@2x-3fe53c7b538e75655d552a3aa8525aef.png";